import React from 'react'

export default function PageNotFound() {
    return (
        <section className="content">
            <div className="error-page">
                <h2 className="headline">404</h2>
                <div className="error-content">
                    <h3><i className="fas fa-exclamation-triangle text-warning" /> Página no encontrada.</h3>
                    <p>
                        El sitio al que intenta acceder no se encuentra disponible o no existe.
                    </p>
                </div>
                {/* /.error-content */}
            </div>
            {/* /.error-page */}
        </section>

    )
}
